module.exports = __webpack_public_path__ + "assets/587d8fdab6c042c0982ee0e24c01d25b.json";